var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('FooterMain')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Moazagotl"},[_c('img',{attrs:{"src":require("../assets/moazagotl.svg"),"alt":"Moazagotl not loaded, fridge..."}})])
}]

export { render, staticRenderFns }